import { render } from "./dashboardform.vue?vue&type=template&id=86fa45e2&scoped=true"
import script from "./dashboardform.vue?vue&type=script&lang=js"
export * from "./dashboardform.vue?vue&type=script&lang=js"

import "./dashboardform.vue?vue&type=style&index=0&id=86fa45e2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-86fa45e2"]])

export default __exports__